<style scoped lang="scss">
.wrap-primer {
  .top_one {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .title {
    h3 {
      font-size: 24px;
      font-weight: bold;
    }
  }

  .el-steps {
    width: 350px;
  }

  .el-button {
    font-size: 20px;
    padding: 14px 20px;
  }

  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
    -moz-appearance: textfield;
  }

  //.product{
  //  display: flex;
  //  align-items: center;
  //  text-align: left;
  //  .img-box{
  //    width:106px;
  //    height:106px;
  //    display: flex;
  //    align-items: center;
  //    justify-content: center;
  //    overflow: hidden;
  //  }
  //  img{
  //    width:106px;
  //    margin-right: 20px;
  //  }
  //  .title{
  //    font-size: 16px;
  //  }
  //  p{
  //    color:#999;
  //  }
  //}
  //.total{
  //  background: #F0F0F0;
  //  text-align: right;
  //  display: flex;
  //  justify-content: space-between;
  //  align-items: center;
  //  padding-left: 20px;
  //  span{
  //    margin-right:30px;
  //    display: inline-flex;
  //    align-items: center;
  //  }
  //  .price{
  //    font-weight: bold;
  //    font-size: 20px;
  //    color: #014492;
  //    small{
  //      font-size: 12px;
  //      font-weight: normal;
  //    }
  //  }
  //  .el-button{
  //    font-size: 20px;
  //    padding:14px 20px;
  //  }
  //}
}

//.charts{
//  overflow: auto;
//  .top{
//    font-size: 16px;
//    margin-left: 2px;
//    padding-top: 5px;
//    border-bottom: 1px solid #ccc;
//    padding-bottom: 20px;
//    a{
//      color:#333;
//    }
//  }
//}
</style>
<style scoped>
@import "../../assets/carts.css";
@import "../../assets/reset.css";
</style>
<template>
  <div class="wrap wrap-primer">
    <section class="container">
      <div class="top_one">
        <div class="title">
          <h3>分子产品商城购物车</h3>
        </div>
        <el-steps :active="0" finish-status="success" align-center>
          <el-step title="勾选商品并提交"></el-step>
          <el-step title="确认并提交订单"></el-step>
        </el-steps>
      </div>
      <!--      <div class="charts">-->
      <!--        <ul>-->
      <!--          <li v-for="(item,index) in list" :key="index">-->
      <!--            <div>-->
      <!--              <div class="top">{{ item.kidname }}</div>-->
      <!--              <el-table-->
      <!--                class="mt20"-->
      <!--                ref="multipleTable"-->
      <!--                :data="item.product"-->
      <!--                @select="selectionRow"-->
      <!--                >-->
      <!--                <el-table-column-->
      <!--                  type="selection"-->
      <!--                  width="55">-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  label="产品信息">-->
      <!--                  <template slot-scope="scope">-->
      <!--                    <div class="product">-->
      <!--                      <div class="img-box">-->
      <!--                        <img :src="scope.row.skuThumbnail">-->
      <!--                      </div>-->
      <!--                      <div class="info">-->
      <!--                        <div class="title">{{scope.row.skuName}}</div>-->
      <!--                        <p>货号：{{scope.row.skuCode}}</p>-->
      <!--                        <p>规格：{{scope.row.SpecificationValues}}</p>-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </template>-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  prop="price"-->
      <!--                  label="单价（元）">-->
      <!--                  <template slot-scope="scope">{{scope.row.price | amount}}</template>-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  label="数量">-->
      <!--                  <template slot-scope="scope">-->
      <!--                    <el-input-number v-model="scope.row.quantity" @change="handleCartChange($event)" :min="0"></el-input-number>-->
      <!--                  </template>-->
      <!--                </el-table-column>-->
      <!--                <el-table-column-->
      <!--                  label="操作">-->
      <!--                  <template slot-scope="scope">-->
      <!--                    <span class="text-danger pointer" @click="bindDelete(scope.row.id)">删除</span>-->
      <!--                  </template>-->
      <!--                </el-table-column>-->
      <!--              </el-table>-->
      <!--            </div>-->
      <!--          </li>-->
      <!--      </ul>-->
      <!--      </div>-->
      <!--      <div class="total mt30">-->
      <!--&lt;!&ndash;        <el-checkbox v-model="checkedAll" class="text-danger">删除</el-checkbox>&ndash;&gt;-->
      <!--        <span @click="bindMultiDelete" class="text-danger pointer">删除</span>-->
      <!--        <div>-->
      <!--          <span>已选商品：{{totalNums1}}</span>-->
      <!--          <span>应付金额：<span class="price"><small>￥</small>{{totalPrice1 | amount}}</span></span>-->
      <!--          <el-button type="primary" @click="toConfirm">确认商品信息并提交</el-button>-->
      <!--        </div>-->
      <!--      </div>-->
      <div id="cart" style="margin-top: 30px;">
        <section class="cartMain">
          <div class="cartMain_hd">
            <ul class="order_lists cartTop" style="background: #F0F0F0;">
              <li class="list_con" style="font-size: 18px">商品信息</li>
              <li class="list_info" style="text-align: center;font-size: 18px">商品参数</li>
              <li class="list_price" style="padding-top: 0;text-align: center;font-size: 18px">单价</li>
              <li class="list_amount" style="padding-top: 0;text-align: center;font-size: 18px">数量</li>
              <li class="list_sum" style="padding-top: 0;text-align: center;font-size: 18px">金额</li>
              <li class="list_op" style="padding-top: 0;text-align: center;font-size: 18px">操作</li>

            </ul>
          </div>

          <div class="cartBox" v-for="(item,index) in this.list.cartItems" :key="index">
            <div class="shop_info">
              <div class="all_check">
                <input type="checkbox" id="shop_a" class="shopChoice">
                <label for="shop_a" class="shop" :class="item.check?'mark':''" @click="shop_choose(item)"></label>
              </div>
              <div class="shop_name">
                店铺：<a href="javascript:;">{{ item.storeName }}</a>
              </div>
            </div>
            <div class="order_content">
              <ul class="order_lists" v-for="pro in item.skuVM">
                <li class="list_chk">
                  <input type="checkbox" id="checkbox_2" class="son_check">
                  <label for="checkbox_2" :class="pro.checked?'mark':''" @click="choose(item,pro)"></label>
                </li>
                <li class="list_con">
                  <div class="list_img"><a href="javascript:;"><img :src="pro.skuThumbnail" alt=""></a></div>
                  <div class="list_text"><a href="javascript:;">{{ pro.skuName }}</a>
                  </div>
                </li>
                <li class="list_info">
                  <p class="inst_info_p">
                    <span class="list_info_span">货号：</span>
                    <span class="list_info_span">{{ pro.skuCode }}</span>
                  </p>
                  <p style="padding-bottom: 5px;" class="inst_info_p">
                    <span class="list_info_span">规格：</span>
                    <span class="list_info_span">{{pro.specificationValues[0].value}},{{pro.specificationValues[1].value}}</span>
                  </p>
                </li>
                <li class="list_price">
                  <p class="price">￥{{ pro.price | amount }}</p>
                </li>
                <li class="list_amount">
                  <div class="amount_box">
                    <a href="javascript:;" class="reduce reSty" @click="reduce(pro)">-</a>
                    <input type="number" v-model="pro.quantity" class="sum" v-on:input="calculate(pro)">
                    <a href="javascript:;" class="plus" @click="add(pro)">+</a>
                  </div>
                </li>
                <li class="list_sum">
                  <p class="sum_price">￥{{ pro.subtotal | amount }}</p>
                </li>
                <li class="list_op">
                  <p class="del"><a href="javascript:;" class="delBtn" @click="del(pro)">删除商品</a></p>
                </li>
              </ul>
            </div>
          </div>
          <!--底部-->
          <div class="bar-wrapper">
            <div class="bar-left">
              <div class="list_chk">
                <!--所有商品全选-->
                <input type="checkbox" id="all" class="whole_check">
                <label for="all" :class="list.status?'mark':''" @click="cart_choose()"></label>
                全选
              </div>
            </div>
            <div class="bar-right">
              <div class="piece">已选商品<strong class="piece_num">{{ this.list.allnum }}</strong>件</div>
              <div class="totalMoney">共计: <strong class="total_text">￥{{ this.list.allsum | amount }}</strong>
              </div>
              <!--              <div class="calBtn"><a href="javascript:;">结算</a></div>-->
              <el-button type="primary" @click="toConfirm">确认商品信息并提交</el-button>
            </div>
          </div>
        </section>
        <section class="model_bg"></section>
      </div>
    </section>
  </div>
</template>

<script>
import {carts1, updateCarts, deleteCarts1} from '@/services/api.index'

export default {
  inject: ['reload'],
  data() {
    return {
      chose: [],
      chose1: [],
      chose2: [],
      CBD: false,
      list:{},
      fetchData: {
        list: [
          {
            shop_id: 1,
            shop_name: '搜猎人艺术生活',
            products: [
              {
                pro_id: 101,
                text: '洗面奶洗面奶洗面奶洗面奶洗面奶洗面奶洗面奶洗面奶',
                price: 480,
                num: 1,
                sendNum:0,
                gui: '默认',
                chi: '16*16*3(cm)',
                img: require('../../assets/img/carts/1.png'),
                sum: 480,
                checked: false//商品选中状态
              },
              {
                pro_id: 102,
                text: '花露水花露水花露水花露水花露水花露水花露水花露水',
                price: 680,
                num: 1,
                sendNum:0,
                gui: '默认',
                chi: '16*16*3(cm)',
                img: require('../../assets/img/carts/2.png'),
                sum: 680,
                checked: false
              },
              {
                pro_id: 103,
                text: '燕麦片燕麦片燕麦片燕麦片燕麦片燕麦片燕麦片燕麦片',
                price: 380,
                num: 1,
                gui: '默认',
                sendNum:0,
                chi: '16*16*3(cm)',
                img: require('../../assets/img/carts/3.png'),
                sum: 380,
                checked: false
              }
            ],
            check: false,//店铺选中状态
            choose: 0,//商品选中个数
          },
          {
            shop_id: 2,
            shop_name: '卷卷旗舰店',
            products: [
              {
                pro_id: 201,
                text: '剃须刀剃须刀剃须刀剃须刀剃须刀剃须刀剃须刀剃须刀',
                price: 580,
                num: 1,
                sendNum:0,
                gui: '默认',
                chi: '16*16*3(cm)',
                img: require('../../assets/img/carts/4.png'),
                sum: 580,
                checked: false
              },
              {
                pro_id: 202,
                text: '卫生纸卫生纸卫生纸卫生纸卫生纸卫生纸卫生纸卫生纸',
                price: 780,
                num: 1,
                sendNum:0,
                gui: '默认',
                index:false,
                chi: '16*16*3(cm)',
                img: require('../../assets/img/carts/5.png'),
                sum: 780,
                checked: false
              }
            ],
            check: false,
            choose: 0,
          },
          {
            shop_id: 3,
            shop_name: '瓜皮的神秘商店',
            products: [
              {
                pro_id: 301,
                text: '眼镜片眼镜片眼镜片眼镜片眼镜片眼镜片眼镜片眼镜片',
                price: 180,
                num: 1,
                sendNum:0,
                gui: '默认',
                chi: '16*16*3(cm)',
                img: require('../../assets/img/carts/6.png'),
                sum: 180,
                checked: false
              },
              {
                pro_id: 302,
                text: '凑数的凑数的凑数的凑数的凑数的凑数的凑数的凑数的',
                price: 280,
                num: 1,
                sendNum:0,
                index:true,
                gui: '默认',
                chi: '16*16*3(cm)',
                img: require('../../assets/img/carts/7.png'),
                sum: 280,
                checked: false
              }
            ],
            check: false,
            choose: 0,
          }
        ],
        status: false,//全选选中状态
        all_choose: 0,//店铺选中个数
        all_sum: 0,//总计价格
        all_num: 0,//总计数量
      }
    }
  },
  created() {
    this.getCarts()
  },
  methods: {
    getCarts() {
      carts1().then(res => {
        this.list = res.data
        // console.log(res)
        // this.totalPrice = 0
        // this.totalNums = 0
        // res.data.map(item => {
        //   this.totalPrice += item.price * item.quantity
        //   this.totalNums += item.quantity
        // })
      })

    },
    choose_true(item, pro) {
      pro.checked = true//将商品选中状态改为true
      ++item.choose === item.skuVM.length ? item.check = true : ''//这里执行了两部，选中商品数量先+1，再与该店铺商品数量比较，如果相等就更改店铺选中状态为true
      item.check ? ++this.list.allchoose === this.list.cartItems.length ? this.list.status = true : this.list.status = false : ''//如果店铺选中状态改为true，选中店铺数量先+1，再与店铺数量比较，如果相等就更改全选选中状态为true
      this.list.allsum += pro.subtotal
      this.list.allnum += pro.quantity
    },
    //删除单个
    del(e) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCarts1(e.skuId).then(() => {
          this.$message.success('删除成功！')
          this.getCarts()
          this.reload()
        })
      })
    },
    choose_false(item, pro) {
      pro.checked = false//将商品选中状态改为false
      --item.choose//选中商品数量-1
      if (item.check) {//如果店铺是被选中的，更改店铺选中状态
        item.check = false
        --this.list.allchoose//并且选中店铺数量-1
      }
      this.list.status = false//无论之前全选的状态，将其改为false就行
      this.list.allsum -= pro.subtotal//商品总计价格变动
      this.list.allnum -= pro.quantity
      item.skuVM.forEach((v) => {
        if (v.checked !== false) {
          this.chose1.push(v)
        }
      })
      this.chose.push(item)
    },
    choose(item, pro) {
      !pro.checked ? this.choose_true(item, pro) : this.choose_false(item, pro)
      item.skuVM.forEach((v) => {
        if (v.checked !== false) {
          this.chose1.push(v)
        }
      })
      this.chose.push(item)
    },
    shop_true(item) {
      item.skuVM.forEach((pro) => {
        pro.checked === false && this.choose_true(item, pro)//循环店铺中的商品，先筛选出目前没选中的商品，给它执行choosetrue函数
        if (pro.checked !== false) {
          this.chose2.push(pro)
        }
      })
      this.chose.push(item)
    },
    shop_false(item) {
      item.skuVM.forEach((pro) => {
        pro.checked === true && this.choose_false(item, pro)//循环店铺中的商品，先筛选出目前被选中的商品，给它执行choosefalse函数
      })
    },
    shop_choose(item) {
      !item.check ? this.shop_true(item) : this.shop_false(item)
    },
    cart_choose() {
      this.list.status = !this.list.status//取反改变状态
      this.list.status ?
        this.list.cartItems.forEach((item) => this.shop_true(item)) :
        this.list.cartItems.forEach((item) => this.shop_false(item))//根据取反后的状态进行相应的店铺按钮操作
    },
    add(pro) {
      pro.quantity++
      pro.subtotal += pro.price
      if (pro.checked) {
        this.list.allnum++
        this.list.allsum += pro.price
      }
    },
    reduce(pro) {
      if (pro.quantity === 1) return
      pro.quantity--
      pro.subtotal -= pro.price
      if (pro.checked) {
        this.list.allnum--
        this.list.allsum -= pro.price
      }
    },
    calculate(pro) {
      let old_sum = pro.quantity//之前的总价
      let old_num = old_sum / pro.price//之前的数量
      pro.quantity = parseInt(pro.quantity)
      pro.quantity > 0 ? pro.subtotal = pro.quantity * pro.price : pro.quantity = old_num//如果输入数量大于0，计算价格，否则返回之前的数量
      let diff_sum = pro.subtotal - old_sum//差价
      let diff_num = pro.quantity - old_num//差量
      if (pro.checked) {//如果商品被选中
        this.list.allsum += diff_sum//计算总价
        this.list.allnum += diff_num//计算总量
      }
    },
    toConfirm() {
      if (this.list.length === 0) {
        this.$message.error('请添加商品')
        return
      }
      if (this.allnum === 0) {
        return this.$message.error('商品数量不能为0')
      }
      // let aa = []
      let cc = []
      let bb = []
      // aa = this.chose.map(item => item.shop_id)
      cc = this.chose1.map(item => item.skuId)
      bb = this.chose2.map(item => item.quantity)
      // console.log(cc, 'cc')
      // console.log(this.chose2, 'bb')
      // if (aa.length) {
      //   localStorage.removeItem('chart_one')
      //   localStorage.removeItem('charts')
      //   this.baseMethods.setLocalObj('chart', [...new Set(this.chose)])
      //   this.$router.push('/products/chart_confirm?type=chart')
      // }
      if (cc.length) {
        localStorage.removeItem('chart_one')
        // localStorage.removeItem('chart')
        this.baseMethods.setLocalObj('chart', [...new Set(this.chose)])
        this.baseMethods.setLocalObj('charts', [...new Set(this.chose1)])
        this.$router.push('/products/chart_confirm?type=chart')
      }
      if (bb.length) {
        // localStorage.removeItem('chart')
        localStorage.removeItem('charts')
        for (let i = 0; i < this.chose1.length; i++) {
          this.chose2.push(this.chose1[i])
        }
        let mar = []
        mar = this.chose2.filter(item => item.checked === true)
        console.log([...new Set(mar)])
        this.baseMethods.setLocalObj('chart', [...new Set(this.chose)])
        this.baseMethods.setLocalObj('chart_one', [...new Set(mar)])
        this.$router.push('/products/chart_confirm?type=chart')
      }
    }
  }
}
// export default {
//   inject: ['reload'],
//   data () {
//     return {
//       checkedAll: false,
//       tableData: [],
//       chooseCharts: [],
//       chooseCharts1: [],
//       chooseCharts2: [],
//       list:[
//         {
//           kid:1,
//           kidname:'实验1',
//           skuCode:'10×100 µL',
//           SpecificationValues:'白色',
//           price:550,
//           quantity:1,
//           id:1,
//           skuName:'EHA105',
//           skuThumbnail:'https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/2534323e6a834c7fa935d6e2e1b055de.jpg',
//         },
//         {
//           kid:2,
//           kidname:'实验2',
//           skuCode:'10×100 µL',
//           SpecificationValues:'白色2',
//           price:550,
//           quantity:2,
//           id:2,
//           skuName:'EHA105',
//           skuThumbnail:'https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/2534323e6a834c7fa935d6e2e1b055de.jpg',
//         },
//         {
//           kid:3,
//           kidname:'实验3',
//           skuCode:'10×100 µL',
//           SpecificationValues:'白色3',
//           price:550,
//           quantity:3,
//           id:3,
//           skuName:'EHA105',
//           skuThumbnail:'https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/2534323e6a834c7fa935d6e2e1b055de.jpg'
//         },
//         {
//           kid:4,
//           kidname:'实验4',
//           skuCode:'10×100 µL',
//           SpecificationValues:'白色4',
//           price:550,
//           quantity:4,
//           id:4,
//           skuName:'EHA105',
//           skuThumbnail:'https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/2534323e6a834c7fa935d6e2e1b055de.jpg',
//         },
//       ],
//       totalPrice: 0,
//       totalNums: 0,
//       totalPrice1: 0,
//       totalNums1: 0
//     }
//   },
//   created() {
//     this.getCarts()
//
//   },
//   methods: {
//     getCarts () {
//       this.tableData = this.list
//       this.list.map((item,index)=>{    //  把原数组循环一下
//         let data = this.tableData.filter(items => {
//           return items.kid === item.kid
//         })
//         item.product = []
//         item.product = data
//       });
//       const res = new Map();
//       this.list = this.list.filter((arr) => !res.has(arr.kid) && res.set(arr.kid, 1))
//       console.log("this.list",this.list)
//       // this.tableData = this.list
//       // console.log("this.tableData",this.tableData)
//       // carts().then(res => {
//       //   console.log(res)
//       //   this.totalPrice = 0
//       //   this.totalNums = 0
//       //   // res.data.map(item => {
//       //   //   this.totalPrice += item.price * item.quantity
//       //   //   this.totalNums += item.quantity
//       //   // })
//       //   this.tableData = res.data.cartItems
//       //   this.list = res.data.cartItems
//       // })
//     },
//     towNumber(val) {
//       return val.toFixed(2)
//     },
//     // 购物车更新
//     handleCartChange(value) {
//       if(value > this.chooseCharts2){
//         this.totalPrice1 = this.chooseCharts1 * value
//         this.totalNums1 = value
//       }else{
//         this.totalPrice1 = this.chooseCharts1 * value
//         this.totalNums1 = value
//       }
//       // updateCarts(id, value).then(() => {
//       //   this.getCarts()
//       //   this.reload()
//       // })
//       // this.getCarts()
//       this.reload()
//     },
//     // 批量选择
//     selectionRow(selection, row){
//       this.chooseCharts = row
//       this.chooseCharts1 = row.price
//       this.chooseCharts2 = row.quantity
//       let selected = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
//       if(selected){
//         this.totalPrice1 += row.price * row.quantity
//         this.totalNums1 += row.quantity
//
//       }else{
//         this.totalPrice1 -= row.price * row.quantity
//         this.totalNums1 -= row.quantity
//       }
//     },
//     // handleSelectionChange (val) {
//     //   this.chooseCharts = val
//     //   console.log(val)
//     //   this.chooseCharts1 = val.map((v) => v.price)
//     //   this.chooseCharts2 = val.map((v) => v.quantity)
//     //
//     //     // this.totalPrice1 = 0
//     //     // this.totalNums1 = 0
//     //     this.chooseCharts.map(item => {
//     //       this.totalPrice1 += item.price * item.quantity
//     //       this.totalNums1 += item.quantity
//     //     })
//     //   // }
//     //   // if(val.length === 1){
//     //   //   this.totalPrice1 = this.chooseCharts1 * this.chooseCharts2
//     //   //   this.totalNums1 = Number(this.chooseCharts2)
//     //   // }else{
//     //   //   this.totalPrice1 = 0
//     //   //   this.totalNums1 = 0
//     //   //   val.map(item => {
//     //   //     this.totalPrice1 += item.price * item.quantity
//     //   //     this.totalNums1 += item.quantity
//     //   //   })
//     //   // }
//     // },
//     // 删除购物车
//     bindDelete (id) {
//       deleteCarts1(id).then(() => {
//         this.$message.success('删除成功！')
//         this.getCarts()
//         this.reload()
//       })
//     },
//     // 批量删除购物车
//     bindMultiDelete () {
//       if (this.chooseCharts.length === 0) {
//         this.$message.warning('您还没有选择要删除的商品')
//         return
//       }
//       let ids = ''
//       this.chooseCharts.map(item => {
//         ids += `${item.id},`
//       })
//       ids = ids.slice(0, ids.length - 1)
//       deleteCarts(ids).then(() => {
//         this.$message.success('删除成功！')
//         this.getCarts()
//         this.reload()
//       })
//     },

//   }
// }
</script>



// WEBPACK FOOTER //
// src/views/products/chart.vue